import React, { useState } from 'react';
import { WizardForm } from '../components/WizardForm';
import { QrCodeIcon, AlertTriangleIcon, CheckCircleIcon, CreditCardIcon, FileTextIcon } from 'lucide-react';
export function SmartPermitIssuance() {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    smartId: '',
    harvesterName: '',
    resource: '',
    compartment: '',
    duration: '',
    paymentStatus: 'pending',
    // Three-Gate Check Status
    banPeriod: false,
    blacklist: false,
    blcExpiry: false,
    activeTrip: false,
    quotaReached: false
  });
  const wizardSteps = [{
    title: 'Scan Smart ID',
    description: 'Scan Harvester ID'
  }, {
    title: 'Permit Details',
    description: 'Resource & Compartment'
  }, {
    title: 'Three-Gate Check',
    calculate: true,
    description: 'System validation engine'
  }, {
    title: 'Payment & Issue',
    description: 'Confirm and generate'
  }];
  const runValidationEngine = () => {
    // Simulate validation logic
    setFormData(prev => ({
      ...prev,
      banPeriod: prev.resource === 'Honey' && new Date().getMonth() > 5,
      blacklist: Math.random() > 0.95,
      blcExpiry: Math.random() > 0.95,
      activeTrip: Math.random() > 0.9,
      quotaReached: Math.random() > 0.95
    }));
  };
  const isBlocked = formData.banPeriod || formData.blacklist || formData.blcExpiry || formData.activeTrip || formData.quotaReached;
  return <div className="space-y-6" data-id="element-1975">
      <div data-id="element-1976">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1977">
          Smart Permit Issuance
        </h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-1978">
          Resource-specific permit generation with automated validation engine
        </p>
      </div>

      <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={step => {
      if (step === 2 && currentStep === 1) {
        runValidationEngine();
      }
      setCurrentStep(step);
    }} onSubmit={() => {
      alert('Permit Generated Successfully with QR Code!');
      setCurrentStep(0);
      setFormData({
        smartId: '',
        harvesterName: '',
        resource: '',
        compartment: '',
        duration: '',
        paymentStatus: 'pending',
        banPeriod: false,
        blacklist: false,
        blcExpiry: false,
        activeTrip: false,
        quotaReached: false
      });
    }} data-id="element-1979">
        {currentStep === 0 && <div className="space-y-6" data-id="element-1980">
            <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-8 text-center" data-id="element-1981">
              <QrCodeIcon size={48} className="mx-auto text-gray-400 mb-4" data-id="element-1982" />
              <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-1983">
                Scan Harvester Smart ID
              </h3>
              <p className="text-sm text-gray-500 mb-6" data-id="element-1984">
                Use the RFID scanner or enter the ID manually
              </p>
              <div className="max-w-xs mx-auto flex gap-2" data-id="element-1985">
                <input type="text" value={formData.smartId} onChange={e => setFormData({
              ...formData,
              smartId: e.target.value
            })} placeholder="Enter Smart ID..." className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1986" />
                <button onClick={() => setFormData({
              ...formData,
              harvesterName: 'Rahim Uddin (Verified)'
            })} className="px-4 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32]" data-id="element-1987">
                  Verify
                </button>
              </div>
            </div>
            {formData.harvesterName && <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-center gap-3" data-id="element-1988">
                <CheckCircleIcon className="text-green-600" data-id="element-1989" />
                <span className="font-medium text-green-900" data-id="element-1990">
                  {formData.harvesterName}
                </span>
              </div>}
          </div>}

        {currentStep === 1 && <div className="space-y-4" data-id="element-1991">
            <div data-id="element-1992">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1993">
                Resource Type *
              </label>
              <select value={formData.resource} onChange={e => setFormData({
            ...formData,
            resource: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1994">
                <option value="" data-id="element-1995">Select Resource</option>
                <option value="Fish" data-id="element-1996">Fish</option>
                <option value="Honey" data-id="element-1997">Honey</option>
                <option value="Wood" data-id="element-1998">Wood</option>
                <option value="Golpata" data-id="element-1999">Golpata</option>
              </select>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-2000">
              <div data-id="element-2001">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2002">
                  Forest Compartment *
                </label>
                <select value={formData.compartment} onChange={e => setFormData({
              ...formData,
              compartment: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2003">
                  <option value="" data-id="element-2004">Select Compartment</option>
                  <option value="C-12" data-id="element-2005">Compartment 12</option>
                  <option value="C-14" data-id="element-2006">Compartment 14</option>
                  <option value="C-21" data-id="element-2007">Compartment 21</option>
                </select>
              </div>
              <div data-id="element-2008">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2009">
                  Duration (Days) *
                </label>
                <input type="number" value={formData.duration} onChange={e => setFormData({
              ...formData,
              duration: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2010" />
              </div>
            </div>
          </div>}

        {currentStep === 2 && <div className="space-y-6" data-id="element-2011">
            <h3 className="font-bold text-gray-900 border-b pb-2" data-id="element-2012">
              Validation Engine Results
            </h3>

            <div className="grid gap-4" data-id="element-2013">
              {/* Three-Gate Check */}
              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.banPeriod ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`} data-id="element-2014">
                {formData.banPeriod ? <AlertTriangleIcon className="text-red-600 mt-0.5" size={20} data-id="element-2015" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2016" />}
                <div data-id="element-2017">
                  <div className={`font-semibold ${formData.banPeriod ? 'text-red-900' : 'text-green-900'}`} data-id="element-2018">
                    1. Ban Period Check
                  </div>
                  <div className={`text-sm ${formData.banPeriod ? 'text-red-700' : 'text-green-700'}`} data-id="element-2019">
                    {formData.banPeriod ? `Active ban period for ${formData.resource}. Issuance blocked.` : 'No active ban period.'}
                  </div>
                </div>
              </div>

              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.blacklist ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`} data-id="element-2020">
                {formData.blacklist ? <AlertTriangleIcon className="text-red-600 mt-0.5" size={20} data-id="element-2021" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2022" />}
                <div data-id="element-2023">
                  <div className={`font-semibold ${formData.blacklist ? 'text-red-900' : 'text-green-900'}`} data-id="element-2024">
                    2. Blacklist Check
                  </div>
                  <div className={`text-sm ${formData.blacklist ? 'text-red-700' : 'text-green-700'}`} data-id="element-2025">
                    {formData.blacklist ? 'Harvester is blacklisted.' : 'Harvester is clear.'}
                  </div>
                </div>
              </div>

              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.blcExpiry ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`} data-id="element-2026">
                {formData.blcExpiry ? <AlertTriangleIcon className="text-red-600 mt-0.5" size={20} data-id="element-2027" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2028" />}
                <div data-id="element-2029">
                  <div className={`font-semibold ${formData.blcExpiry ? 'text-red-900' : 'text-green-900'}`} data-id="element-2030">
                    3. BLC Expiry Check
                  </div>
                  <div className={`text-sm ${formData.blcExpiry ? 'text-red-700' : 'text-green-700'}`} data-id="element-2031">
                    {formData.blcExpiry ? 'Associated BLC is expired.' : 'BLC is valid.'}
                  </div>
                </div>
              </div>

              {/* Additional Policies */}
              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.activeTrip ? 'bg-orange-50 border-orange-200' : 'bg-green-50 border-green-200'}`} data-id="element-2032">
                {formData.activeTrip ? <AlertTriangleIcon className="text-orange-600 mt-0.5" size={20} data-id="element-2033" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2034" />}
                <div data-id="element-2035">
                  <div className={`font-semibold ${formData.activeTrip ? 'text-orange-900' : 'text-green-900'}`} data-id="element-2036">
                    One-Trip Policy
                  </div>
                  <div className={`text-sm ${formData.activeTrip ? 'text-orange-700' : 'text-green-700'}`} data-id="element-2037">
                    {formData.activeTrip ? 'Previous trip not marked returned. Cannot issue new permit.' : 'No active trips.'}
                  </div>
                </div>
              </div>

              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.quotaReached ? 'bg-orange-50 border-orange-200' : 'bg-green-50 border-green-200'}`} data-id="element-2038">
                {formData.quotaReached ? <AlertTriangleIcon className="text-orange-600 mt-0.5" size={20} data-id="element-2039" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2040" />}
                <div data-id="element-2041">
                  <div className={`font-semibold ${formData.quotaReached ? 'text-orange-900' : 'text-green-900'}`} data-id="element-2042">
                    Resource Quota
                  </div>
                  <div className={`text-sm ${formData.quotaReached ? 'text-orange-700' : 'text-green-700'}`} data-id="element-2043">
                    {formData.quotaReached ? 'Station limit reached for this resource.' : 'Quota available.'}
                  </div>
                </div>
              </div>
            </div>

            {isBlocked && <div className="bg-red-100 text-red-800 p-4 rounded-lg font-bold text-center" data-id="element-2044">
                ISSUANCE BLOCKED: Please resolve the flagged issues above.
              </div>}
          </div>}

        {currentStep === 3 && <div className="space-y-6" data-id="element-2045">
            {!isBlocked ? <>
                <div className="bg-blue-50 p-6 rounded-lg border border-blue-200 flex items-center justify-between" data-id="element-2046">
                  <div data-id="element-2047">
                    <h4 className="font-bold text-blue-900 flex items-center gap-2" data-id="element-2048">
                      <CreditCardIcon size={20} data-id="element-2049" /> Payment Confirmation
                    </h4>
                    <p className="text-sm text-blue-700 mt-1" data-id="element-2050">
                      Total Fee: ৳ 1,250
                    </p>
                  </div>
                  <button onClick={() => setFormData({
              ...formData,
              paymentStatus: 'paid'
            })} className={`px-6 py-2 rounded-lg font-medium transition-colors ${formData.paymentStatus === 'paid' ? 'bg-green-600 text-white' : 'bg-blue-600 text-white hover:bg-blue-700'}`} data-id="element-2051">
                    {formData.paymentStatus === 'paid' ? 'Paid ✓' : 'Confirm Payment'}
                  </button>
                </div>

                {formData.paymentStatus === 'paid' && <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-8 text-center animate-in fade-in" data-id="element-2052">
                    <FileTextIcon size={48} className="mx-auto text-[#1B5E20] mb-4" data-id="element-2053" />
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-2054">
                      Digital Permit Ready
                    </h3>
                    <p className="text-sm text-gray-500 mb-4" data-id="element-2055">
                      Permit will be generated with a secure QR code and digital
                      signature.
                    </p>
                    <div className="inline-block bg-white px-4 py-2 rounded-lg border border-gray-200 font-mono font-bold text-lg text-gray-900" data-id="element-2056">
                      PRM-2024-
                      {Math.floor(Math.random() * 10000).toString().padStart(4, '0')}
                    </div>
                  </div>}
              </> : <div className="text-center py-8 text-red-600 font-bold" data-id="element-2057">
                Cannot proceed. Validation checks failed.
              </div>}
          </div>}
      </WizardForm>
    </div>;
}